import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Calendar, MapPin, Users, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { getConference, registerConference, initializePayment } from '../utils/api';
import { toast } from 'sonner';

export const ConferenceDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [conference, setConference] = useState(null);
  const [formData, setFormData] = useState({ full_name: '', email: '', phone: '', organization: '' });

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getConference(id);
        setConference(res.data);
      } catch (err) {
        toast.error('Conference not found');
      }
    };
    load();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const reg = await registerConference({ conference_id: conference.id, ...formData, amount: conference.fee });
      const payment = await initializePayment({ email: formData.email, amount: conference.fee, payment_type: 'conference', item_id: reg.data.id });
      window.location.href = payment.data.authorization_url;
    } catch (err) {
      toast.error('Registration failed');
    }
  };

  if (!conference) return <div className="min-h-screen flex items-center justify-center"><p>Loading...</p></div>;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-blue-700 text-white py-12">
        <div className="max-w-7xl mx-auto px-4">
          <Button variant="ghost" onClick={() => navigate('/conferences')} className="text-white mb-4">
            <ArrowLeft className="mr-2 h-4 w-4" /> Back
          </Button>
          <h1 className="text-4xl font-bold mb-4" style={{fontFamily: 'Work Sans'}}>{conference.title}</h1>
          <p className="text-blue-100 text-lg">{conference.description}</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 gap-8">
          <Card>
            <CardHeader><CardTitle>Details</CardTitle></CardHeader>
            <CardContent className="space-y-4">
              <div className="flex items-start"><Calendar className="h-5 w-5 mr-3 mt-1 text-blue-700"/><div><p className="font-semibold">Date</p><p className="text-gray-600">{conference.date}</p></div></div>
              <div className="flex items-start"><MapPin className="h-5 w-5 mr-3 mt-1 text-blue-700"/><div><p className="font-semibold">Mode</p><p className="text-gray-600">{conference.mode}</p></div></div>
              <div className="pt-4 border-t"><p className="text-sm text-gray-600 mb-2">Fee</p><p className="text-3xl font-bold text-blue-700">₦{conference.fee.toLocaleString()}</p></div>
            </CardContent>
          </Card>
          <Card>
            <CardHeader><CardTitle>Register</CardTitle></CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div><Label>Full Name *</Label><Input required value={formData.full_name} onChange={(e) => setFormData({...formData, full_name: e.target.value})}/></div>
                <div><Label>Email *</Label><Input type="email" required value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})}/></div>
                <div><Label>Phone *</Label><Input required value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})}/></div>
                <div><Label>Organization</Label><Input value={formData.organization} onChange={(e) => setFormData({...formData, organization: e.target.value})}/></div>
                <Button type="submit" className="w-full" size="lg">Proceed to Payment</Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};